// A chat row's time (cas-mobile-shell D6): relative inside 24 h ("Just now", "3 minutes ago",
// "5 hours ago"), then "Yesterday · 9:14 PM", a weekday inside a week, else "Oct 3".
const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function formatWhen(ts: number, now: number = Date.now()): string {
  if (!ts) return "";
  const age = now - ts;
  if (age < MINUTE) return "Just now";
  if (age < HOUR) {
    const m = Math.floor(age / MINUTE);
    return m === 1 ? "1 minute ago" : `${m} minutes ago`;
  }
  if (age < DAY) {
    const h = Math.floor(age / HOUR);
    return h === 1 ? "1 hour ago" : `${h} hours ago`;
  }
  const d = new Date(ts);
  const time = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Yesterday · ${time}`;
  if (age < 7 * DAY) return `${d.toLocaleDateString([], { weekday: "short" })} · ${time}`;
  return d.toLocaleDateString([], { month: "short", day: "numeric" });
}
